import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form'

import Box from '../components/Box'
import { addCalendar } from '../actions/calendars'
import { renderInputField, renderSelectField, renderTextAreaField } from '../utils/forms'

class CalendarAddForm extends React.Component {
       constructor(props) {
              super(props)

              this.submit = this.submit.bind(this)
       }

       submit(props) {

              return this.props.addCalendar(props)
                     .then(response => {
                            if (response.error) {
                                   throw new SubmissionError({
                                          _error: response.error.message,
                                          ...response.error.fields
                                   })
                            }

                            // If in modal mode, close modal and refresh
                            if (this.props.isModal) {
                                   this.props.closeModal();
                                   if (this.props.refreshCalendars) {
                                          this.props.refreshCalendars();
                                   }
                            }

                            return response
                     })
       }

       render() {
              const { error, pristine, submitting, handleSubmit, role, customers, isModal } = this.props

              return (
                     <form onSubmit={handleSubmit(this.submit)}>
                            {!isModal && (
                                   <h1>
                                          <span className="text-vw-dark">CALENDARIO </span>
                                          <span className="text-vw-light">NUEVO</span>
                                   </h1>
                            )}

                            <div className="row">
                                   {role === 'ADMIN' && (
                                          <div className="col-xs-12 col-md-6">
                                                 <Field name="CustomerId" component={renderSelectField} label="Cliente">
                                                        <option value="">Seleccionar Cliente</option>
                                                        {customers &&
                                                               customers
                                                                      .filter((customer) => customer.Type === 'GENERAL' || customer.Type === 'LICENCIA_BASICA' || customer.Type === 'LICENCIA_PRO')
                                                                      .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                                                                      .map((c) => (
                                                                             <option key={c._id} value={c._id}>
                                                                                    {c.Fullname}
                                                                             </option>
                                                                      ))}
                                                 </Field>
                                          </div>
                                   )}
                                   <div className={`col-xs-12 ${role === 'ADMIN' ? 'col-md-6' : 'col-md-12'}`}>
                                          <Field name="Name"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="Nombre del calendario" />
                                   </div>
                            </div>
                            {error && <div className="alert alert-danger" style={{ marginTop: '1rem' }}>{error}</div>}
                            {!isModal && (
                                   <div style={{ marginTop: '2rem' }}>
                                          <button className="btn bg-vw-light text-white mr-2" type="submit"
                                                 disabled={pristine || submitting}>
                                                 <i className="fas fa-save mr-2"></i>
                                                 Guardar
                                          </button>
                                   </div>
                            )}
                            {isModal && (
                                   <div className="d-flex justify-content-end" style={{ marginTop: '2rem', gap: '10px' }}>
                                          <button 
                                                 className="btn btn-secondary" 
                                                 type="button" 
                                                 onClick={this.props.closeModal}
                                                 style={{ minWidth: '100px' }}>
                                                 <i className="fas fa-times mr-2"></i>
                                                 Cancelar
                                          </button>
                                          <button 
                                                 className="btn bg-vw-light text-white" 
                                                 type="submit"
                                                 disabled={pristine || submitting}
                                                 style={{ minWidth: '100px' }}>
                                                 <i className="fas fa-save mr-2"></i>
                                                 Guardar
                                          </button>
                                   </div>
                            )}
                     </form>
              )
       }
}

CalendarAddForm = reduxForm({
       form: 'CalendarAddForm',
       keepDirtyOnReinitialize: true,
       enableReinitialize: true,
       updateUnregisteredFields: true,
       onSubmitSuccess: (result, dispatch, props) => {
              // Only push to route if NOT in modal mode
              if (!props.isModal) {
                     props.push(`/calendars`)
              }
       }
})(CalendarAddForm)

const mapStateToProps = state => ({
       auth: state.auth,
       role: state.auth.role,
       type: state.auth.type,
       fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
       addCalendar: bindActionCreators(addCalendar, dispatch),
       push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarAddForm)
